/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AwardPayPromoMutationVariables = {
    mobile: string;
    code: string;
};
export type AwardPayPromoMutationResponse = {
    readonly awardPromo: {
        readonly result: string | null;
    } | null;
};
export type AwardPayPromoMutation = {
    readonly response: AwardPayPromoMutationResponse;
    readonly variables: AwardPayPromoMutationVariables;
};



/*
mutation AwardPayPromoMutation(
  $mobile: String!
  $code: String!
) {
  awardPromo(mobile: $mobile, code: $code) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "code"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobile"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      },
      {
        "kind": "Variable",
        "name": "mobile",
        "variableName": "mobile"
      }
    ],
    "concreteType": "AwardPromo",
    "kind": "LinkedField",
    "name": "awardPromo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AwardPayPromoMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AwardPayPromoMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ce1dc8f1e75a5f09afaa4a3ae02cf357",
    "id": null,
    "metadata": {},
    "name": "AwardPayPromoMutation",
    "operationKind": "mutation",
    "text": "mutation AwardPayPromoMutation(\n  $mobile: String!\n  $code: String!\n) {\n  awardPromo(mobile: $mobile, code: $code) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b497853d664dd3d1c373236efd77df01';
export default node;
